import { apiUrl } from "../../utils/url";
import { HttpClient, HttpError } from "../HttpClient";
import {
  IRuleServiceDurationService,
  RuleServiceDurationRequest,
  RuleServiceDurationResponse,
} from "./IRuleServiceDurationService";

export class RuleServiceDurationService implements IRuleServiceDurationService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async calculateServiceDuration(
    data: RuleServiceDurationRequest,
  ): Promise<RuleServiceDurationResponse> {
    try {
      const response = await this.httpClient.post<RuleServiceDurationResponse>(
        "/ruleServiceDuration/calculate",
        data,
      );

      return response;
    } catch (error) {
      if (error instanceof HttpError) {
        throw new HttpError({
          status: error.status,
          statusText: error.statusText,
          responseText: error.responseText,
          responseData: error.responseData,
          url: error.url,
          method: error.method,
          message: error.message,
        });
      }

      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível calcular a duração do serviço. Confirme o serviço e o perfil do animal.",
      );
    }
  }
}
